import { schema, normalize } from 'normalizr';

const Membership = new schema.Entity('memberships');
const ConsumerFieldValue = new schema.Entity('consumerFieldValues');
const Purchase = new schema.Entity('purchases', {
  memberships: [Membership],
  consumerFieldValues: [ConsumerFieldValue],
});

export const normalizePurchase = data => normalize(data, Purchase);

export const normalizePurchases = data => normalize(data, [Purchase]);



// WEBPACK FOOTER //
// ./src/reducers/schemas.js